function AnalystRatingsCard(props) {
  const { items = [] } = props.chartData || {};

  return (
    <div className="col-12 col-xl-4">
      <div className="card border-light shadow-sm analyst-ratings-card-wrapper">
        <div className="card-header d-flex flex-row align-items-center">
          <div className="h4">Analyst Ratings</div>
        </div>
        <div className="card-body analyst-ratings-card">
          <div className="analyst-ratings-grid">
            {items.map((item) => (
              <button
                type="button"
                key={item.ticker}
                className="analyst-ratings-square"
                style={{ backgroundColor: item.color }}
                aria-label={item.ticker}
              >
                <span className="analyst-ratings-square-tooltip">{item.ticker}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AnalystRatingsCard;
